import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { get, post } from "../../../components/Utils/CallApi";
import { setError } from "../appSlice";

// Fetch Teams
export const fetchTeams = createAsyncThunk(
  "team/fetchTeams",
  async (
    { companyId, page, limit, categoryId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      let params = `companyId=${companyId}&sectionType=team&page=${page}&limit=${limit}`;
      if (categoryId) {
        params += `&categoryId=${categoryId}`;
      }
      const response = await get("sections/data/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Save Team Member
export const saveTeam = createAsyncThunk(
  "team/saveTeam",
  async (
    { payload, sectionId, files },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/data/save",
        payload,
        state.app,
        sectionId,
        files
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Update Team Member
export const updateTeam = createAsyncThunk(
  "team/updateTeam",
  async (team, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      // TODO: Implement update logic if needed
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Get Single Team Member
export const getTeam = createAsyncThunk(
  "team/getTeam",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `id=${id}&sectionType=team`;
      const response = await get("sections/data/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Action Creators
export const addTeam = (team) => ({
  type: "team/addTeam",
  payload: team,
});

export const editTeam = (updatedTeam) => ({
  type: "team/editTeam",
  payload: updatedTeam,
});

// Team Slice
const teamSlice = createSlice({
  name: "team",
  initialState: {
    teamList: [],
    loading: false,
    error: null,
  },
  reducers: {
    addTeam: (state, action) => {
      if (action.payload) {
        state.teamList.push(action.payload);
      }
    },
    editTeam: (state, action) => {
      const index = state.teamList.findIndex(
        (team) => team.id === action.payload.id
      );
      if (index !== -1) {
        state.teamList[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teamList = action.payload;
      })
      .addCase(fetchTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teamSlice.reducer;
